import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from "react";
import StateMap from "../../store/stateMap";
import { useFormik } from 'formik';
import { popinfo } from "../../component/Fancybox/Fancybox";
import {QuillBuilder} from "../../component/RichEditor/RichEditor"
import { format, parseISO } from 'date-fns';
import api from '../../api';
import _ from "lodash";
import "../../sass/form/form.scss";
import "./style.scss";

const EditEventForm = (props) => {

    const [initiative, setInitiative] = useState(props.sentInitiative);

    const [formDataLoad, setFormDataLoad] = useState(true);

    const [eventTypes, setEventTypes] = useState(false);

    const [rundownWYSIWYG, setRundownWYSIWYG] = useState(false);

    const rundownElement = useRef(null)

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {

            if(value === null)
            {
                value = '';
            }

            if(attribute == 'Rundown'){
                rundownWYSIWYG.setContents(rundownWYSIWYG.clipboard.convert(value), 'silent');
            }
            else if(attribute == 'EventTypes')
            {
                if(value.length > 0)
                {
                    formik.setFieldValue(attribute,value[0]['EventTypeID']);
                }
            }
            else
            {
                formik.setFieldValue(attribute, value);
            }

        });
    }

    const formik = useFormik({
        initialValues: {
            InitiativeID    : initiative.InitiativeID
            ,Location       : ''
            ,CampusArea     : ''
            ,Organizer      : ''
            ,Rundown        : ''
            ,EventForms     : ''
            ,EventTypes     : ''
            ,EventSelfDescribeType  : ''
            ,EventBGA       : []
            ,EventStartTime : ''
            ,EventEndTime   : ''
        }
        ,onSubmit: values => {

            var SavingLoader = popinfo('loader', 'Saving Event Information', 'Detailed event information help crowd <br/> has better understanding of your initiative');

            // return console.log(values);

            if(values.EventTypes !== 'other')
            {
                values.EventSelfDescribeType = '';
            }

            api('/InitiativeEvent', 'post', _.assignIn({}, values, {
                Rundown : rundownWYSIWYG.root.innerHTML
            }), 'Bearer ' + props.auth.token)
                .then(function(response){
                    
                    SavingLoader.close();
                    
                    settingFormValues(response.initiative[0]);

                    props.onSave(response.initiative[0]);
                        
                })
                .catch((error) => {
                    popinfo('error', 'Saving Event Information', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {

        if(!rundownElement.current)
        {
            return;
        }

        var rte = QuillBuilder(rundownElement.current, props.auth.token);

        rte.once('editor-change', () => {
            setRundownWYSIWYG(rte);
        });

        rte.setText('\n', 'silent');
    }, []);

    useEffect(() => {

        if(initiative.InitiativeID != props.sentInitiative)
        {
            setInitiative(props.sentInitiative);
        }

    }, [props.sentInitiative])


    useEffect(()=>{

        if(rundownWYSIWYG === false)
        {
            return;
        }

        if(initiative.InitiativeID > 0)
        {
            setFormDataLoad(true);

            api('/EventType', 'get', {
                posts_per_page : -1
            }, 'Bearer ' + props.auth.token)
                .then((response) => {

                    settingFormValues(initiative);

                    setEventTypes(response.types);

                    setFormDataLoad(false);

                })
        }
    }, [rundownWYSIWYG]);

    return (
        <form className="generic-form"  onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <label htmlFor="" className="label">Types of people joining the initiative</label>
                <div className="description">Is this event as a medium to get participants or crew?</div>
                {
                    formDataLoad ? <span className="skeleton"></span> : 
                    <div className="event-look-for flex flex-wrap">
                        <label  className="label" name="EventLookFor" style={{marginRight : '10px'}}>
                            <input 
                                defaultChecked={formik.values.EventLookFor == 'crew'}
                                id="EventLookFor"
                                name="EventLookFor"
                                type="radio" 
                                value="crew" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur} 
                            /> Crew
                        </label>
                        <label  className="label" name="EventLookFor">
                            <input 
                                defaultChecked={formik.values.EventLookFor == 'participant'}
                                id="EventLookFor"
                                name="EventLookFor"
                                type="radio" 
                                value="participant" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur} 
                            /> Participants
                        </label>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Event Time</label>
                <div className="description">For events that are looking for participants, it is better if you also include the time of the event. This will help the event participants.</div>
                <div className='flex-flat'>
                    <div>
                        <label htmlFor="" className="label">Start Time on {format(parseISO(initiative.StartDate), 'dd LLLL Y')} </label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <input type="time" className="form-control text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.EventStartTime}
                                name="EventStartTime"
                            />
                        }
                    </div>
                    <div>
                        <label htmlFor="" className="label">End Time on {format(parseISO(initiative.EndDate), 'dd LLLL Y')}</label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <input type="time" className="form-control text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.EventEndTime}
                                name="EventEndTime"
                            />
                        }
                    </div>
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Event Category</label>
                <div className="description">Choose the category that fits your event</div>
                {
                    eventTypes === false ?<span className="skeleton"></span> : 
                    <div className="event-categories">
                        {
                            eventTypes.map((eventType) => (
                                <label key={eventType.EventTypeID} className="label" name="EventTypes">
                                    <input 
                                        defaultChecked={formik.values.EventTypes.indexOf(eventType.EventTypeID) > -1}
                                        id="EventTypes"
                                        name="EventTypes"
                                        type="radio" 
                                        value={eventType.EventTypeID} 
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur} 
                                    /> <span dangerouslySetInnerHTML={{__html : eventType.TypeName}}></span>
                                </label>
                            ))
                        }
                        <label className="label" name="EventTypes">
                            <input 
                                defaultChecked={formik.values.EventTypes.indexOf('other') > -1}
                                id="EventTypes"
                                name="EventTypes"
                                type="radio" 
                                value="other" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur} 
                            /> <span>Other</span>
                        </label>
                        {
                            formik.values.EventTypes.indexOf('other') > -1 && 
                            <input type="text" className="form-control text" 
                                placeholder='Type your event type ...'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.EventSelfDescribeType}
                                name="EventSelfDescribeType"
                            />
                        }
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Location*</label>
                <div className="description">Type where this event will be held</div>
                {
                    formDataLoad ? <span className="skeleton"></span> : 
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.Location}
                        name="Location"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Organizer*</label>
                <div className="description">Who is responsible for this event</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.Organizer}
                        name="Organizer"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Rundown</label>
                <div className="description">Complete detail of your event activities</div>
                <div ref={rundownElement} id="event-rundown"></div>
            </div>

            <div className="form-group">
                <label htmlFor="" className="label">BINUS Campus</label>
                <div className="description">BINUS Campus this event is held</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.CampusArea} name="CampusArea" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Select Campus</option>
                            {
                                props.config.campus.map((campus) => (
                                    <option value={campus[0]} key={campus[0]}>{campus[1]}</option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Event Forms*</label>
                <div className="description">determine how your event will be held</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.EventForms} name="EventForms"  onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Select Forms</option>
                            {
                                props.config.EventForms.map((event_form) => (
                                    <option value={event_form[0]} key={event_form[0]}>{event_form[1]}</option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            
            <hr />
            <div className="text-right">
                <button type="submit" className='btn btn-orange'>Complete</button>
            </div>
        </form>
    )
}

export default connect(StateMap)(EditEventForm);